module.exports = __webpack_public_path__ + "img/linda.acd26310.jpg";